module.exports = __webpack_public_path__ + "static/giving-3640beb82c446dd3cf8a9a5ec13a793c.jpg";